var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWikiFindLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        isolation: isolate;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #231f20;\n      }\n\n      .cls-3, .cls-4 {\n        font-family: AmericanTypewriter, 'American Typewriter';\n        font-size: 112.87px;\n      }\n\n      .cls-4 {\n        fill: #f8f9fb;\n        opacity: .3;\n      }\n\n      .cls-2 {\n        mix-blend-mode: difference;\n      }\n\n      .cls-5 {\n        stroke-width: 6px;\n      }\n\n      .cls-5, .cls-6, .cls-7 {\n        fill: #fff;\n        stroke: #c2daf1;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-6 {\n        stroke-linecap: round;\n      }\n\n      .cls-6, .cls-7 {\n        stroke-width: 12px;\n      }\n\n      .cls-8 {\n        letter-spacing: .01em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "big"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 342.64,
    cy: 215.19,
    r: 33.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 406.96,
    y1: 274.57,
    x2: 363.52,
    y2: 234.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 427.4,
    y1: 293.44,
    x2: 392.56,
    y2: 261.28
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(11.96 288.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Wiki"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 244.6,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 315.93,
    y: 0
  }, "ind")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(10.05 283.83)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Wiki"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 244.6,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 315.93,
    y: 0
  }, "ind")))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiFindLogo);
export default __webpack_public_path__ + "static/media/wiki-find-logo.c56875d357b2e532aa5bfced2b039bc8.svg";
export { ForwardRef as ReactComponent };